import { type ValueOf } from '@direct-frontend/stdlib';
import { ONBOARDING_EXTERNAL_CHECKOUT_STEPS, ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS } from '#shared/api/onboarding';
import {
    SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES,
    SETTINGS_LOGISTICS_SEARCH_PARAMS_WAREHOUSES,
    settingsAboutRoute,
    settingsLogisticsRoute,
    settingsPaymentRoute,
    settingsProductFeedRoute,
    settingsTestOrderRoute,
    settingsYaMetrikaRoute,
    settingsYcpRoute,
} from '#shared/lib/routes';
import { type OnboardingStepProps, type OnboardingSubtaskProps } from '../lib/types';

export const getCheckoutStepsProps = (
    isBitrix: boolean
): Record<ValueOf<typeof ONBOARDING_EXTERNAL_CHECKOUT_STEPS>, OnboardingStepProps> => {
    return {
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.INSTALL_KIT_MODULE]: {
            description: 'Это необходимо для резервирования остатков при заказе',
            href: settingsYcpRoute.getUrl(),
            name: isBitrix ? 'Подключитесь к модулю для 1С-Битрикс' : 'Подключитесь к API YCP',
        },
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.SPECIFY_COMPANY_INFORMATION]: {
            description: 'Проверьте ИНН, загрузите логотип, и укажите контакты',
            href: settingsAboutRoute.getUrl(),
        },
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.CONFIGURE_DELIVERY_AND_PAYMENT]: {
            description: 'Подключение доставки и оплаты может занимать до семи дней',
            href: settingsLogisticsRoute.getUrl({ searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES }),
            name: 'Настройте доставку и оплату',
        },
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.ADD_PRODUCTS]: {
            description: 'Подключите фид с описанием товаров, ценами и остатками',
            href: settingsProductFeedRoute.getUrl(),
        },
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.CONNECT_YA_METRIC]: {
            description: 'Счётчик Яндекс Метрики необходим для отслеживания событий и аналитики продаж',
            href: settingsYaMetrikaRoute.getUrl(),
        },
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.MAKE_TEST_ORDER]: {
            description: 'Тестовый заказ необходим для проверки работоспособности систем оплаты и передачи в доставку',
            href: settingsTestOrderRoute.getUrl(),
        },
        [ONBOARDING_EXTERNAL_CHECKOUT_STEPS.PUBLISH]: {
            name: 'Опубликовать',
        },
    };
};

export const checkoutSubtasksProps: Record<
    ValueOf<typeof ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS>,
    OnboardingSubtaskProps
> = {
    [ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS.CONFIGURE_PAYMENT]: {
        orderWithinStage: 2,
        href: settingsPaymentRoute.getUrl(),
    },
    [ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS.IMPORT_WAREHOUSES]: {
        orderWithinStage: 1,
        href: settingsLogisticsRoute.getUrl({
            searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_WAREHOUSES,
        }),
    },
    [ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS.CONNECT_DELIVERY]: {
        orderWithinStage: 0,
        href: settingsLogisticsRoute.getUrl({
            searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES,
        }),
    },
};
